import { FormBinder } from './IFormBinder';

const baseTextFieldProps = (bind: FormBinder<string> | undefined) => ({
  onChange: (ev: React.ChangeEvent<any>) => bind?.change(ev.target.value),
  onBlur: () => bind?.blur(),
  value: bind?.value ?? '',
});

export default baseTextFieldProps;